import {KeyTestRowFormField} from "../types/key-tests-modal.types";
import {Validators} from "@angular/forms";

export const titleRowFields: KeyTestRowFormField = {
  key: 'titleRow',
  className: 'key-test-single',
  fields: [
    {
      label: 'Название',
      fieldName: 'title',
      type: 'text',
      validators: [ Validators.required ]
    }
  ]
}

export const rateRowFields: KeyTestRowFormField = {
  key: 'rate',
  className: 'key-test-triple',
  labelRow: 'Ставка',
  fields: [
    {
      label: 'до',
      fieldName: 'bidBefore',
      type: 'number',
      decimals: 4,
      validators: [ Validators.required ]
    },
    {
      label: 'ожидаем',
      fieldName: 'bidExpected',
      type: 'number',
      decimals: 4,
      validators: [ Validators.required ]
    },
    {
      label: 'факт',
      fieldName: 'bidActual',
      type: 'number',
      decimals: 4
    }
  ]
}

export const positionRowFields: KeyTestRowFormField = {
  key: 'position',
  className: 'key-test-triple',
  labelRow: 'Позиция',
  fields: [
    {
      label: 'до',
      fieldName: 'positionBefore',
      type: 'number',
      validators: [ Validators.required ]
    },
    {
      label: 'ожидаем',
      fieldName: 'positionExpected',
      type: 'number',
      validators: [ Validators.required ]
    },
    {
      label: 'факт',
      fieldName: 'positionActual',
      type: 'number'
    }
  ]
}

export const salesRowFields: KeyTestRowFormField = {
  key: 'sales',
  className: 'key-test-triple',
  labelRow: 'Продажи шт. в день',
  fields: [
    {
      label: 'до',
      fieldName: 'dailySalesBefore',
      type: 'number'
    },
    {
      label: 'ожидаем',
      fieldName: 'dailySalesExpected',
      type: 'number'
    },
    {
      label: 'факт',
      fieldName: 'dailySalesActual',
      type: 'number'
    }
  ]
}

export const sroRowFields: KeyTestRowFormField = {
  key: 'sro',
  className: 'key-test-triple',
  labelRow: 'СРО',
  fields: [
    {
      label: 'до',
      fieldName: 'cpoBefore',
      type: 'number',
      decimals: 4
    },
    {
      label: 'ожидаем',
      fieldName: 'cpoExpected',
      type: 'number',
      decimals: 4
    },
    {
      label: 'факт',
      fieldName: 'cpoActual',
      type: 'number',
      decimals: 4
    }
  ]
}

export const advertisingBudgetRowFields: KeyTestRowFormField = {
  key: 'advertising-budget',
  className: 'key-test-triple',
  labelRow: 'Рек. бюджет',
  fields: [
    {
      label: 'до',
      fieldName: 'adBudgetBefore',
      type: 'number',
      decimals: 4
    },
    {
      label: 'ожидаем',
      fieldName: 'adBudgetExpected',
      type: 'number',
      decimals: 4
    },
    {
      label: 'факт',
      fieldName: 'adBudgetActual',
      type: 'number',
      decimals: 4
    }
  ]
}

export const commentRowFields: KeyTestRowFormField = {
  key: 'comment',
  className: 'key-test-comment',
  fields: [
    {
      label: 'Комментарий',
      fieldName: 'comment',
      type: 'textarea'
    }
  ]
}

export const timerRowFields: KeyTestRowFormField = {
  key: 'timer',
  className: 'key-test-double',
  labelRow: 'Таймер',
  fields: [
    {
      label: 'Дата',
      fieldName: 'date',
      type: 'date'
    },
    {
      label: 'Время',
      fieldName: 'time',
      type: 'time'
    }
  ]
}

export const keyTestRowFormFields: Array<KeyTestRowFormField> = [
  titleRowFields,
  rateRowFields,
  positionRowFields,
  salesRowFields,
  sroRowFields,
  advertisingBudgetRowFields,
  commentRowFields,
  timerRowFields
]
